<template>
  <div>
    <div v-for="horse in horses" :key="horse.id" class="margin-bottom">
      <AppShowHorseWithDetails
        v-if="!showNameOnly"
        :horse="horse"
        :details-type="detailsType"
        :profile-link="profileLink"
        :details-to-show="detailsToShow"
        :show-with-registry="showWithRegistry"
        :vaccination-check-date="vaccinationCheckDate"
        show-more-details-btn
        @showHorseDetails="$emit('showHorseDetails', $event)"
      />
      <AppShowHorseName
        v-else
        :horse="horse"
        :show-identifier="showIdentifier"
      />
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowHorseWithDetails from "./AppShowHorseWithDetails.vue";
import AppShowHorseName from "./AppShowHorseName.vue";

export default {
  name: "AppShowHorsesList",
  components: {
    AppShowHorseWithDetails,
    AppShowHorseName
  },
  props: {
    horses: {
      type: Array,
      default() {
        return [];
      }
    },
    detailsToShow: {
      type: Array, // possible values .. TODO
      default() {
        return [];
      }
    },
    showIdentifier: {
      type: Boolean,
      default: false
    },
    profileLink: {
      type: Boolean,
      default: false
    },
    detailsType: {
      type: String,
      default: "default"
    },
    showWithRegistry: {
      type: String,
      default: null
    },
    showNameOnly: {
      type: Boolean,
      default: false
    },
    showMoreDetailsBtn: {
      type: Boolean,
      default: false
    },
    vaccinationCheckDate: {
      type: String,
      default: ""
    }
  },
  fragments: {
    horse: gql`
      fragment _ on Horse {
        ${AppShowHorseWithDetails.fragments.horse}
      }
    `
  }
};
</script>
<style scoped>
.margin-bottom + .margin-bottom {
  margin-top: 12px;
}
</style>
